import React from 'react';
import './Certifications.css';

const certs = [
  {
    name: 'Certificate IV in Cyber Security',
    year: '2025',
  },
];

const Certifications = () => {
  return (
    <section id="certifications" className="certifications">
      <div className="certifications-container">
        <h2 className="certifications-title">Certifications</h2>
        <div className="certs-grid">
          {certs.map((cert, index) => (
            <div key={index} className="cert-card">
              <div className="cert-icon">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 2L4 6V12C4 16.4 7.4 20.5 12 22C16.6 20.5 20 16.4 20 12V6L12 2Z"
                    stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="rgba(52,152,219,0.1)"/>
                  <path d="M9 12L11 14L15 10" stroke="currentColor" strokeWidth="2"
                    strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <div className="cert-info">
                <h3 className="cert-name">{cert.name}</h3>
                <span className="cert-year">{cert.year}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Certifications;
